import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { SharedModule } from './shared/shared.module';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { TranslocoRootModule } from './transloco/transloco-root.module';
import { CustomHttpInterceptor } from './shared/interceptors/http.interceptor';
import AuthGuard from './services/auth-guard';
import OffLineGuard from './services/offline-guard';
import localeTR from '@angular/common/locales/tr';
import localeDE from '@angular/common/locales/de';
import localeNL from '@angular/common/locales/nl';
import { registerLocaleData } from '@angular/common';
import { LegacyNotesComponent } from './pages/legacy-notes/legacy-notes.component';
import { HttpErrorInterceptor } from './shared/interceptors/http-error.interceptor';
import { PaymentResultComponent } from './pages/payment-result/payment-result.component';

registerLocaleData(localeTR);
registerLocaleData(localeDE);
registerLocaleData(localeNL);

@NgModule({
  declarations: [AppComponent, LegacyNotesComponent, PaymentResultComponent],
  entryComponents: [],
  imports: [
    SharedModule,
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    HttpClientModule,
    TranslocoRootModule,

  ],
  providers: [
    AuthGuard,
    OffLineGuard,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    {
      provide: DEFAULT_CURRENCY_CODE,
      useValue: '₺',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
